import { i } from '@instantdb/core';

const _schema = i.schema({
  entities: {
    $users: i.entity({
      email: i.string().unique().indexed(),
    }),

    organizations: i.entity({
      name: i.string(),
      createdAt: i.number().indexed(),
    }),

    memberships: i.entity({
      role: i.string(),
      email: i.string().indexed(),
      status: i.string().indexed(),
      createdAt: i.number().indexed(),
    }),

    comments: i.entity({
      pageUrl: i.string().indexed(),
      pageOrigin: i.string().indexed(),
      pagePath: i.string().indexed(),
      pageTitle: i.string(),
      cssSelector: i.string(),
      xpath: i.string(),
      elementText: i.string(),
      pinX: i.number(),
      pinY: i.number(),
      body: i.string(),
      status: i.string().indexed(),
      authorEmail: i.string().indexed(),
      createdAt: i.number().indexed(),
    }),

    replies: i.entity({
      body: i.string(),
      authorEmail: i.string().indexed(),
      createdAt: i.number().indexed(),
    }),
  },

  links: {
    organizationOwner: {
      forward: { on: 'organizations', has: 'one', label: 'owner' },
      reverse: { on: '$users', has: 'many', label: 'ownedOrgs' },
    },
    membershipOrg: {
      forward: { on: 'memberships', has: 'one', label: 'organization' },
      reverse: { on: 'organizations', has: 'many', label: 'memberships' },
    },
    membershipUser: {
      forward: { on: 'memberships', has: 'one', label: 'user' },
      reverse: { on: '$users', has: 'many', label: 'memberships' },
    },
    commentOrg: {
      forward: { on: 'comments', has: 'one', label: 'organization' },
      reverse: { on: 'organizations', has: 'many', label: 'comments' },
    },
    commentAuthor: {
      forward: { on: 'comments', has: 'one', label: 'author' },
      reverse: { on: '$users', has: 'many', label: 'authoredComments' },
    },
    replyComment: {
      forward: { on: 'replies', has: 'one', label: 'comment' },
      reverse: { on: 'comments', has: 'many', label: 'replies' },
    },
    replyAuthor: {
      forward: { on: 'replies', has: 'one', label: 'author' },
      reverse: { on: '$users', has: 'many', label: 'authoredReplies' },
    },
  },

  rooms: {},
});

type _AppSchema = typeof _schema;
interface AppSchema extends _AppSchema {}
const schema: AppSchema = _schema;

export type { AppSchema };
export default schema;
